import { StatusIndicator, toneFromBadgeVariant } from '@neo/primitives/status-indicator'
import { Tooltip } from '@neo/primitives/tooltip'
import { AlertTriangle } from 'lucide-react'
import { kbStatusBadge } from 'v2/shared/services/rag-adapter'
import type { DocumentStatus } from './types'

// Ingest-status badge shared by the KB lists (agent tab + standalone). On a failed / partial KB it
// shows WHY on hover (the first failure cause), so the user doesn't have to open the detail page to
// find out. The plumbing prefix is stripped so the tooltip reads as an actionable cause.
export const KbStatusBadge = ({
  status,
  errorDetail,
}: {
  status: DocumentStatus | null | undefined
  errorDetail?: string | null
}) => {
  const { label, variant } = kbStatusBadge(status)
  const badge = <StatusIndicator tone={toneFromBadgeVariant(variant)}>{label}</StatusIndicator>
  const showWhy = (status === 'failed' || status === 'completed_with_errors') && !!errorDetail
  if (!showWhy) return badge
  const cause = (errorDetail ?? '')
    .replace(/^pipeline ingest failed:\s*/i, '')
    .replace(/^err:\s*/i, '')
  return (
    <Tooltip content={cause}>
      <span className="inline-flex items-center gap-1 cursor-help">
        {badge}
        <AlertTriangle className="h-4 w-4 text-destructive" />
      </span>
    </Tooltip>
  )
}
